<template>
    <div v-if="trainerPosition" class="dw-root" :style="bgStyle">
        <div class="dw-content">
            <div class="dw-top-row">
                <div class="dw-square-tile" :class="{'dw-square-tile--disabled': isLoading}" @click="!isLoading && travel()">
                    <div class="dw-back-badge-img" :style="wildImgStyle"/>
                    <div class="dw-square-label">{{ $t('common.backToWild') }}</div>
                </div>
                <!-- placeholder pro budoucí detail trenéra - drží místo ve dvousloupcovém gridu -->
                <div class="dw-square-placeholder"/>
            </div>

            <div class="dw-congrats-card" :class="$vuetify.theme.dark ? 'transparent03--dark white--text' : 'transparent03 black--text'">
                <div class="dw-congrats-title">{{ $t('common.congratulations') }}</div>
                <div class="dw-congrats-subtitle">
                    <template v-if="isChallenge">{{ $t('journey.dungeonWin.subtitleChallenge', {elo: dungeonElo}) }}</template>
                    <template v-else-if="bossName">{{ $t('journey.dungeonWin.subtitleBossPrefix') }}<strong>{{ bossName }}</strong>{{ $t('journey.dungeonWin.subtitleBossSuffix', {elo: dungeonElo}) }}</template>
                    <template v-else>{{ $t('journey.dungeonWin.subtitleNoBoss', {elo: dungeonElo}) }}</template>
                </div>
                <div v-if="showReward" class="dw-reward-img-wrap">
                    <v-img
                        :src="require(`@/assets/pic${trainerPosition.trainer.lastStone.picture}`)"
                        class="dw-reward-img"
                        contain
                    />
                </div>
                <div v-if="showReward" class="dw-reward-label">
                    {{ trainerPosition.trainer.lastStone.name }} &middot; {{ $t('journey.dungeonWin.powerLabel') }} {{ trainerPosition.trainer.lastStone.stoneVal }}
                </div>
            </div>

            <div class="dw-toplist-card" :class="$vuetify.theme.dark ? 'transparent03--dark white--text' : 'transparent03 black--text'">
                <div class="dw-toplist-title">{{ $t('journey.dungeonWin.toplistTitle') }}</div>
                <div class="dw-toplist-scroll">
                    <ToplistTable
                        :toplist="toplist"
                        :headers="['', $t('journey.dungeonWin.headerTrainer'), $t('journey.dungeonWin.headerDungeonPoints'), $t('journey.dungeonWin.headerDay'), $t('journey.dungeonWin.headerDate')]"
                        :keys="['index','trainer','elo','days','created']"
                        :actual-trainer="toplistTrainer"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Sdílená win obrazovka pro DUNGEON_WIN i DUNGEON_CHALLENGE_WIN (stará
    // DungeonWin.vue/DungeonChallengeWin.vue byly skoro identické) - prop
    // `isChallenge` přepíná text/toplist filtr přesně jako
    // journeyApi.dungeonsToplist(). Design viz claude/components/journey-dungeon.md.
    import {mapActions, mapGetters} from 'vuex';
    import * as journeyApi from '@/api/journeyApi';
    import ToplistTable from '@/components/journey/positions/pieces/ToplistTable';

    export default {
        name: 'DungeonWinNext',
        components: {ToplistTable},
        props: {
            trainerPosition: {type: Object, default: null},
            isChallenge: {type: Boolean, default: false},
        },
        data() {
            return {
                toplist: [],
                toplistTrainer: null,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
                isLoading: 'journey/isLoading',
            }),
            bgStyle() {
                return {backgroundImage: `url(${require('@/assets/pic/position/DUNGEON_WIN.png')})`};
            },
            wildImgStyle() {
                // stejný obrázek jako TrainerWildFightWinNext.vue / dlaždice "Wild road" v CityNext.vue
                return {backgroundImage: `url(${require('@/assets/pic/web/forest.png')})`};
            },
            dungeonElo() {
                return this.trainerPosition.wild.dungeon.elo;
            },
            bossName() {
                const boss = this.trainerPosition.pokemonFight && this.trainerPosition.pokemonFight.opponentPokemon;
                return boss ? boss.name : '';
            },
            showReward() {
                const stone = this.trainerPosition.trainer.lastStone;
                if (!stone || !stone.picture) {
                    return false;
                }
                return this.isChallenge ? !!this.trainerPosition.wild.dungeon.challengeRewardLevel : true;
            },
        },
        watch: {
            trainerPosition() {
                this.getToplist();
            }
        },
        created() {
            this.trainerInfoMessages(this.user.id);
            this.getToplist();
        },
        methods: {
            ...mapActions({
                fetchData: 'journey/fetchObject',
                positionPost: 'journey/positionPost',
                trainerInfoMessages: 'trainer/loadInfoMessages',
            }),
            travel() {
                this.positionPost(journeyApi.travel(this.trainerPosition.id));
            },
            getToplist() {
                this.fetchData(journeyApi.dungeonsToplist(this.trainerPosition.days, this.user.id, this.isChallenge)).then((data) => {
                    this.toplist = data['toplist'];
                    this.toplistTrainer = data['trainer'];
                });
            },
        },
    }
</script>

<style scoped>
.dw-root {
    position: fixed;
    inset: 0;
    height: 100%;
    background-size: cover;
    background-position: center;
    overflow-y: auto;
}
.dw-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    /* poslední číslo (bottom) = rezerva pro globální TeamBottomSheet (App.vue) -
       54px, viz komentář v TrainerFightWinNext.vue (.dw-root je taky fixed/inset:0) */
    padding: 74px 16px 54px 16px;
    height: 100%;
    box-sizing: border-box;
}
/* stejný výškový rozpočet jako TrainerWildFightWinNext.vue - top-row 25%
   (smršťuje se přednostně na 20% podlahu), congrats/toplist karty 50/50 ze zbytku */
.dw-top-row {
    width: 100%;
    max-width: 420px;
    flex: 0 3 25%;
    min-height: 20%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    justify-items: stretch;
}
.dw-square-tile {
    width: 100%;
    height: 100%;
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.dw-square-tile--disabled {
    pointer-events: none;
    opacity: 0.6;
}
.dw-square-placeholder {
    width: 100%;
}
.dw-back-badge-img {
    flex: 1 1 auto;
    min-height: 0;
    width: auto;
    max-width: 100%;
    aspect-ratio: 1;
    border-radius: 14px;
    background-size: cover;
    background-position: center;
    border: 5px solid #C0C0C0;
    box-shadow: 0 3px 8px rgba(0,0,0,0.5);
    box-sizing: border-box;
}
.dw-square-label {
    margin-top: -14px;
    position: relative;
    z-index: 1;
    background: rgba(0,0,0,0.65);
    color: #fff;
    font-size: clamp(15px, 15cqw, 30px);
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 10px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.6);
    white-space: nowrap;
}
.dw-congrats-card {
    width: 100%;
    max-width: 420px;
    flex: 1 1 37.5%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border-radius: 18px;
    padding: 18px 16px 10px 16px;
    text-align: center;
    box-shadow: 2px 3px 10px rgba(0,0,0,0.35);
    box-sizing: border-box;
}
.dw-congrats-title {
    flex: none;
    font-size: 26px;
    font-weight: 800;
}
.dw-congrats-subtitle {
    flex: none;
    font-size: 18px;
    font-weight: 600;
    margin-top: 2px;
}
/* nalezeny kamen "tak velky jak to jen jde" - stejny princip jako
   .twf-trainer-img-wrap v TrainerWildFightWinNext.vue */
.dw-reward-img-wrap {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 6px;
}
.dw-reward-img {
    height: 100%;
    width: 100%;
}
.dw-reward-label {
    flex: none;
    font-size: 16px;
    font-weight: 600;
    margin-top: 4px;
}
.dw-toplist-card {
    width: 100%;
    max-width: 420px;
    flex: 1 0 37.5%;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    padding: 10px 10px 4px 10px;
    box-shadow: 2px 3px 8px rgba(0,0,0,0.3);
    box-sizing: border-box;
}
.dw-toplist-title {
    flex: none;
    text-align: center;
    font-size: 26px;
    font-weight: 800;
    margin-bottom: 4px;
}
/* font-size dědí default ToplistTable.vue (bez vlastního zvětšení) - jinak
   se Date sloupec zabaluje na víc řádků, viz stejný fix v TrainerFightWinNext.vue */
.dw-toplist-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}
/* dungeon toplist má o sloupec navíc než trenérský (index/pořadí + "Dungeon's
   points"), takže Day sloupec (4. z 5) se pod 440px schová, ať má Date dost místa */
@media (max-width: 440px) {
    .dw-toplist-scroll ::v-deep th:nth-child(4),
    .dw-toplist-scroll ::v-deep td:nth-child(4) {
        display: none;
    }
    .dw-toplist-scroll ::v-deep th,
    .dw-toplist-scroll ::v-deep td {
        padding: 0 6px !important;
    }
}
</style>
